// TODO: get rid of this, currently present for legacy support as Tealium uses this to communicate via events
import ElcDispatcher from './analytics/elc_dispatcher';

window.site = window.site || {};
window.site.elcEvents = new ElcDispatcher();

import './analytics/connector';
import './analytics/events/tracker';
import AnalyticsEventRouter from './analytics/events/router';
import tealium from './analytics/tealium';

//initialize analytics event router
new AnalyticsEventRouter();
tealium.init({
  tealiumProfile: window.utag_cfg_ovrd?.settings?.tealiumProfile || '',
  tealiumUrl: window.utag_cfg_ovrd?.settings?.tealiumUrl || '',
  tealiumEnv: window.utag_cfg_ovrd?.settings?.tealiumEnv || ''
});
